import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { MapPin, Phone, Mail, Clock, FileText } from "lucide-react";

export default function Footer() {
  const { footer } = useContent();

  const links = [
    { name: "Start", href: "/" },
    { name: "Organy", href: "/organy" },
    { name: "Status prawny", href: "/status" },
    { name: "Szkolenia", href: "/szkolenia" },
    { name: "Kontakt", href: "/kontakt" },
    { name: "Forum", href: "/forum" },
  ];

  return (
    <footer className="relative mt-24 bg-ztk-navydark text-slate-300" data-testid="site-footer">
      <div className="cable-accent h-[3px] w-full" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="mb-4 rounded-lg bg-white/95 p-3 inline-block">
              <img src="/logo-ztkig.png" alt="ZTK" className="h-12 w-auto" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400" data-testid="footer-tagline">
              {footer.tagline}
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-slate-400">
              <FileText className="h-3.5 w-3.5 text-ztk-yellow" />
              KRS: <span className="font-mono text-slate-200" data-testid="footer-krs">{footer.krs}</span>
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-white">Nawigacja</h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-sm text-slate-400 transition-colors hover:text-ztk-glow">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-white">Kontakt</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2.5" data-testid="footer-address">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ztk-glow" />
                <span>{footer.address}</span>
              </li>
              <li>
                <a href={`tel:${(footer.phone || "").replace(/\s/g, "")}`} className="flex items-center gap-2.5 transition-colors hover:text-ztk-glow" data-testid="footer-phone">
                  <Phone className="h-4 w-4 shrink-0 text-ztk-glow" />
                  {footer.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${footer.email}`} className="flex items-center gap-2.5 transition-colors hover:text-ztk-glow" data-testid="footer-email">
                  <Mail className="h-4 w-4 shrink-0 text-ztk-glow" />
                  {footer.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Clock className="h-4 w-4 shrink-0 text-ztk-glow" />
                {footer.hours}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-white">Siedziba</h4>
            <div className="overflow-hidden rounded-xl border border-white/10">
              <iframe
                title="Mapa siedziby"
                width="100%"
                height="150"
                loading="lazy"
                style={{ border: 0, filter: "grayscale(0.2)" }}
                src="https://www.openstreetmap.org/export/embed.html?bbox=19.455%2C51.760%2C19.475%2C51.772&layer=mapnik&marker=51.766%2C19.465"
              />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
